import { render } from "./CaseStudyPage.vue?vue&type=template&id=388380fd&scoped=true"
import script from "./CaseStudyPage.vue?vue&type=script&lang=js"
export * from "./CaseStudyPage.vue?vue&type=script&lang=js"

import "./CaseStudyPage.vue?vue&type=style&index=0&id=388380fd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Jerald Pamugas\\OneDrive\\Desktop\\Projects\\jerald-pamugas-1\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388380fd"]])

export default __exports__